<template>
    <div id="maincontainer">
        
        <div v-show="form_success === 0" class="content">
            
            <form @submit.prevent="saveApplication">
                <h1 class="title">Personal Details</h1>
                <div class="field">
                    <label class="label">Select Your Governing Body *</label>
                    <div class="select is-fullwidth">
                        <select  v-model="governing_body_id" required>
                            <option value="">Please select</option>
                            <option v-for="row in governing_bodies" :key="row.id" :value="row.id">{{ row.name }}</option>
                        </select>
                        
                        
                    </div>
                    <p class="help ">Please contact us if you do not see your NGB listed above. We may still offer funding for your sport.</p>
                </div>

                <div class="field">
                    <label class="label">Applicant Name *</label>
                    <div class="columns">
                        <div class="column is-2">
                            <div class="control">
                                <input class="input" type="text" placeholder="Title" v-model="title" maxlength="20">
                            </div>
                        </div>
                        <div class="column is-5">
                            <div class="control">
                                <input class="input" type="text" required placeholder="First Name" v-model="forename" maxlength="100">
                            </div>
                        </div>
                        <div class="column is-5">
                            <div class="control">
                                <input class="input" type="text" required placeholder="Last Name" v-model="surname" maxlength="100">
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Date of Birth</label>
                            <div class="control">
                                <datepicker v-model="dob" input-class="input" name="dob" monday-first   format="dd/MM/yyyy" @closed="calculateAge" placeholder="dd/mm/yyyy"></datepicker>
                              
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Email</label>
                            <div class="control">
                                <input class="input" type="email" required placeholder="" v-model="email" maxlength="200">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="field" v-show="age < 18">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Parent/Guardian Name</label>
                            <div class="control">
                                 <input class="input" type="text"  placeholder="" v-model="parent_name" maxlength="200">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Relationship to Applicant</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="parent_relationship" maxlength="200">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="field" v-show="age < 18">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Parent/Guardian Telephone</label>
                            <div class="control">
                                 <input class="input" type="text"  placeholder="" v-model="parent_telephone" maxlength="200">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Parent/Guardian Email</label>
                            <div class="control">
                                <input class="input" type="email"  placeholder="" v-model="parent_email" maxlength="200">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Telephone (Home)</label>
                            <div class="control">
                                <input class="input" type="text" placeholder="" v-model="telephone" maxlength="100">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Telephone (Mobile)</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="mobile" maxlength="100">
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div class="field">
                   <label class="label">Council Area</label>
                    <div class="select is-fullwidth">
                        <select  v-model="council_area_id" required>
                            <option value="">Please select</option>
                            <option v-for="row in council_areas" :key="row.id" :value="row.id">{{ row.name }}</option>
                        </select>
                    </div>
                    
                </div>
                
                <div class="field">
                   <label class="label">Address</label>
                    <div class="control">
                        <input class="input" type="text"  placeholder="" v-model="address" maxlength="200">
                        
                    </div>
                    
                </div>
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">City</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="city" maxlength="100">
                                
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">State/Province/Region</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="state" maxlength="100">
                            </div>
                        </div>
                        
                    </div>
                </div>
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Postcode</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="postcode" maxlength="50">
                                
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Country</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="country" maxlength="100">
                            </div>
                        </div>
                        
                    </div>
                </div>
                
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Employment</label>
                            <div class="select is-fullwidth">
                                <select v-model="employment" class="input">
                                    <option value="">Please select ...</option>
                                    <option value="Full Time">Full Time</option>
                                    <option value="Part Time">Part Time</option>
                                    <option value="N/A">N/A</option>
                                </select>
                            </div>
                        </div>
                        <div class="column ">
                             <label class="label">Education</label>
                            <div class="select is-fullwidth">
                                <select v-model="education" class="input">
                                    <option value="">Please select ...</option>
                                    <option value="Full Time">Full Time</option>
                                    <option value="Part Time">Part Time</option>
                                    <option value="N/A">N/A</option>
                                </select>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
                <br />
                <h1 class="title mb-0">Funding Requirements</h1>
                <p class="mb-4" style="display:none">You can help the NGB by entering most of the information below but please note the NGB have to right to amend and confirm all the information provided.</p>
                <br />
                <div class="field">
                    <label class="label">Coaching Course Details</label>
                    <div class="control">
                        <input class="input" type="text"  placeholder="" v-model="target_event" maxlength="500">
                    </div>
                </div>

                <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Date of Coaching Course</label>
                            <div class="control">
                                <input class="input" type="text" placeholder="" v-model="target_event_date" maxlength="100">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Venue of Coaching Course</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="target_event_venue" maxlength="100">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Estimated Cost of Coaching Course</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="target_event_cost" maxlength="100">
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div class="field">
                    <label class="label">Associated Costs for Coaching Qualification (eg. a boat licence for water sports)</label>
                    <p class="" style="display:none"><em>Detailed programme of training and competitions that will assist the Trust to make the appropriate level of award.</em></p>
                    
                    
                
                    <div class="columns mb-0" >
                        
                        <div class="column is-8 ">
                           <strong>Details</strong>
                        </div>
                        <div class="column is-3">
                            <strong>Cost (&pound;)</strong>
                        </div>
                        <div class="column is-1">
                            
                        </div>
                    </div>
                    <div class="columns mb-0" v-for="(row, index) in training" :key="index">
                        
                        <div class="column is-8">
                            <div class="control">
                                <input class="input" type="text" placeholder="Details" v-model="row.details" maxlength="500">
                            </div>
                        </div>
                        <div class="column is-3">
                            <div class="control">
                                <input class="input" type="text"  placeholder="Cost (£)" v-model="row.cost" maxlength="100" >
                            </div>
                        </div>
                        <div class="column is-1">
                            <a class="delete is-large" @click="training.splice(index, 1);"></a>
                        </div>
                    </div>
                    <button class="button is-info is-small" type="button" @click="addTrainingItem()"> 
                        <span class="icon">
                        <i class="fa fa-plus"></i>
                        </span>
                        <span>Add New Item</span>
                    </button>
                </div>

                <div class="field">
                   <label class="label"> Details of other financial support revieved in past 12 months (Must be fully competed)</label>
                   <div class="columns mb-0" >
                        
                        <div class="column is-4 ">
                           <strong>Finance Body</strong>
                        </div>
                        <div class="column is-2">
                            <strong>Amount (&pound;)</strong>
                        </div>
                        <div class="column is-2">
                            <strong>Date Received</strong>
                        </div>
                        <div class="column is-3">
                            <strong>Other Comments</strong>
                        </div>
                        <div class="column is-1">
                            
                        </div>
                    </div>
                    <div class="columns mb-0" v-for="(row, index) in support" :key="index">
                        
                        <div class="column is-4">
                            <div class="select is-fullwidth">
                                <select v-model="row.finance_body">
                                    <option value="">Select Finance Body ...</option>
                                    <option v-for="(option, index) in finance_bodies" v-bind:value="option" :key="index">{{ option }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="column is-2">
                            <div class="control">
                                <input class="input" type="text"  placeholder="Amount (£)" v-model="row.amount" maxlength="100" >
                            </div>
                        </div>
                         <div class="column is-2">
                            <div class="control">
                                <input class="input" type="text"  placeholder="Date Received" v-model="row.date" maxlength="100" >
                            </div>
                        </div>
                         <div class="column is-3">
                            <div class="control">
                                <input class="input" type="text"  placeholder="Comments" v-model="row.comments" maxlength="500" >
                            </div>
                        </div>
                        <div class="column is-1">
                            <a class="delete is-large" @click="support.splice(index, 1);"></a>
                        </div>
                    </div>
                    <button class="button is-info is-small" type="button" @click="addSupportItem()"> 
                        <span class="icon">
                        <i class="fa fa-plus"></i>
                        </span>
                        <span>Add New Item</span>
                    </button>
                </div>

                <div class="field">
                   <label class="label">Governing Body Report and Recommendations (to be completed by Governing Body only)</label>
                   
                    
                    
                </div>

                <div class="field">
                   <label class="label">Supporting Statement</label>
                   <p>Athletes applying must demonstrate in their application a desire to use their coaching qualification to give back to their sport, particularly at entry level.</p>
                   <textarea class="textarea" placeholder="" v-model="supporting_statement"></textarea>
                </div>

                <div class="field">
                   <label class="label">Potential</label>
                   <textarea class="textarea" placeholder="Please outline the long term potential of this applicant" v-model="potential"></textarea>
                </div>

                <div class="field">
                   <label class="label">Previous Funding</label>
                   <textarea class="textarea" placeholder="Detail any previous funding received from MPT in the past" v-model="previous_funding"></textarea>
                </div>

                <div class="field">
                   <label class="label">Other Relevant Comments</label>
                   <textarea class="textarea" placeholder="Please confine comments to sporting history.  It would also be helpful to know the competitive numbers of those involved in this discipline." v-model="other_comments"></textarea>
                </div>

                <div class="field">
                   <label class="label">Assessment of financial need</label>
                   <div class="columns mb-0" >
                        
                        <div class="column is-3 ">
                           <strong>Priority</strong>
                        </div>
                        <div class="column is-8">
                            <strong>Comments</strong>
                        </div>
                       
                        <div class="column is-1">
                            
                        </div>
                    </div>
                    <div class="columns mb-0" v-for="(row, index) in needs" :key="index">
                        
                        <div class="column is-3">
                            <div class="select is-fullwidth">
                                <select v-model="row.priority">
                                    <option value="">Select Priority ...</option>
                                    <option v-for="(option, index) in priority_options" v-bind:value="option" :key="index">{{ option }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="column is-8">
                            <div class="control">
                                <input class="input" type="text"  placeholder="Comments" v-model="row.comments" maxlength="500" >
                            </div>
                        </div>
                        
                        <div class="column is-1">
                            <a class="delete is-large" @click="needs.splice(index, 1);"></a>
                        </div>
                    </div>
                    <button class="button is-info is-small" type="button" @click="addNeedItem()"> 
                        <span class="icon">
                        <i class="fa fa-plus"></i>
                        </span>
                        <span>Add New Item</span>
                    </button>
                </div>

                

                <br />
                <h1 class="title mb-0">Terms and Conditions</h1>
                <ol class="list" >
                    <li class="list-item">
                        <ol type="A">
                            <li>If an award is made to me by the Trust, I will allow my name, photograph, achievements and details of my award to be published on the Trusts website and other social media outlets. *my address will not be published. If requested I will give interviews to the press and undertake to keep the Trust updated on my progress and achievements.</li>
                            <li>I consent to the Trust keeping my personal details as part of the Trust Alumni.</li>
                        </ol>
                    </li>
                    <li>If I am under 18 years of age I must at all times be accompanied by a parent or guardian aged over 21 years.</li>
                    <li>Any action or behaviour on my part which would bring the Trust into disrepute will result in my award being suspended pending investigations by the Directors.</li>
                    
                    <li>Any award made to me by the Trust will be withdrawn if the Directors believe, subsequent to their investigations, the reputation of the Trust is at risk.</li>
                    <li>The Trust will recover any monies awarded to me if the Trusts Directors consider my actions or behaviour incompatible with the aims of my sport or the Trust. The Trust is wholly reliant on the goodwill and donations from the public and actions which would impact negatively on the good work of the Trust and affect donations to benefit other athletes are unacceptable.</li>
                    <li>I accept if a coaching award is made to me, the award monies must be used for the purpose stated in my application.</li>

                    <li>Consent Clause – If the applicant receives an award from the Trust it will be paid to the applicant unless the applicant consents in writing (to be forwarded to the Trust before payment of any award) to the payment of the award to the Governing Body.</li>
                    <li>These terms and conditions must be read in conjunction with the application form and no variation of either is permitted.</li>
                    <li>No contract, express or implied, is created between the Trust and the applicant when the application form is submitted to the Trust.</li>
                    <li>It must be demonstrated that if awarded a coaching award it will benefit the community particularly at the entry level to sport.</li>
                    <li>The coaching awards are aimed at 16 – 25 years old.</li>
                    <li>If an applicant wants to apply for eg a boat licence then this will be considered however full details and costs must be given.</li>
                    <li>Athletes who receive a coaching award will be required to give an update every six months following acceptance of the award.</li>
                    <li>There will be an athlete academy for those awarded and you will be expected to attend where possible.</li>
                </ol>

                <label class="checkbox">
                    <input type="checkbox" v-model="agree_terms" value="1" required >
                    I agree to the terms and conditions above
                    </label>
                <div class="field is-grouped">
                    <div class="control">
                        <button class="button is-success" :disabled="isSubmitting">Submit My Application</button>
                    </div>
                </div>
            </form>
        </div>
        
        <div v-show="form_success === 1" class="notification is-success" id="success_container">
            Your application has been submitted successfully. Your sporting liaison officer will now review your details.
        </div>

         <div v-show="form_error === 1" class="notification is-danger">
            There has been an error submitting your application. Please review your details and try again.
        </div>
    </div>
</template>

<style scoped>
#maincontainer {
  background:#23346B;
  color:#fff;
}
h1, h2, h3, h4, h5, h6, p, span, .label {color : #fff}

.content h1, strong, #app {color:#fff}

.vdp-datepicker {color:black}
</style>

<script>
import ApplicationService from '@/services/ApplicationService.js';
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        Datepicker
    },
    data() {
        return {
            form_success: 0,
            form_error: 0,
            agree_terms:null,
            isSubmitting: null,
            age:18,
            governing_bodies:[],
            council_areas:[],
            ranking_areas:['Northern Ireland', 'GB/UK', 'Ireland', 'Europe', 'World'],
            priority_options:['Low', 'Medium', 'High'],
            finance_bodies: ['Sport NI: Athlete Support Programme', 'Sport Ireland: International Carding Scheme', 'Borough/District/City Council/ Sports Advisory Council', 
            'University Bursary', 'Previous Mary Peters Trust Award', 'Other – please state in comments >'],
            governing_body_id:null,
            title:"",
            forename:"",
            surname:"",
            dob:"",
            parent_name: "",
            parent_email: "",
            parent_telephone: "",
            parent_relationship: "",
            telephone:"",
            mobile:"",
            school_name:"",
            social_handle:"",
            email:"",
            address:"",
            city:"",
            state:"",
            postcode:"",
            country:"",
            council_area:"",
            council_area_id: '',
            employment:"",
            education:"",
            target_event: "",
            target_event_date:"",
            target_event_venue:"",
            target_event_cost:"",
            supporting_statement: "",
            previous_funding: "",
            achievements:"",
            potential:"",
            other_comments:"",
            training: [{'details': '', 'cost' : ''}, {'details': '', 'cost' : ''}, {'details': '', 'cost' : ''}],
            support: [{'finance_body': '', 'amount' : '', 'date' : '', 'comments' : ''}],
            ranking: [{'area': '', 'rank' : ''}],
             needs: [{'priority': '', 'comments' : ''}],
            
        }
  },
  created() {
    this.getGoverningBodies();
    this.getCouncilAreas();
    
  },
  methods: {
     resizeWindow(scroll) {
         if(scroll == 1)
         {
            window.parent.postMessage({
          frameHeight: 200,
          scroll: 1
        }, '*');
         }
         else{
            var height = document.getElementById('container').offsetHeight + 100;
            window.parent.postMessage({
            frameHeight: height
            
            }, '*');
            //console.log(height);
         }
        
        
     },
     async getGoverningBodies() {
        //const accessToken = await this.$auth.getTokenSilently()
      // Use the eventService to call the getEventSingle() method
      ApplicationService.getGoverningBodies("")
      .then(
        (governing_bodies => {
          this.$set(this, "governing_bodies", governing_bodies);
        }).bind(this)
      );
    },
    async getCouncilAreas() {
        //const accessToken = await this.$auth.getTokenSilently()
      // Use the eventService to call the getEventSingle() method
      ApplicationService.getCouncilAreas("")
      .then(
        (council_areas => {
          this.$set(this, "council_areas", council_areas);
        }).bind(this)
      );
    },
      async saveApplication() {
        //const accessToken = await this.$auth.getTokenSilently()

        this.isSubmitting = true;

        if(!confirm("Please confirm all details are correct before submitting. If you are happy, please press OK to confirm your submission."))
        {
            this.isSubmitting = false;
            return false;
        }
        
        var formdata = { 
            coaching: 1,
            governing_body_id: this.governing_body_id, 
        title: this.title, 
        forename: this.forename, 
        surname: this.surname, 
        dob:this.dob,
        parent_name:this.parent_name,
        parent_email:this.parent_email,
        parent_telephone:this.parent_telephone,
        parent_relationship:this.parent_relationship,
        email:this.email,
        telephone:this.telephone,
        mobile:this.mobile,
        council_area:this.council_area,
        council_area_id:this.council_area_id,
        address:this.address,
        city:this.city,
        state:this.state,
        postcode:this.postcode,
        country:this.country,
        school_name:this.school_name,
        social_handle:this.social_handle,
        employment:this.employment,
        education:this.education,
        target_event: this.target_event,
        target_event_date:this.target_event_date,
        target_event_venue:this.target_event_venue,
        target_event_cost:this.target_event_cost,
        training: this.training,
        support: this.support,
        ranking: this.ranking,
        supporting_statement:this.supporting_statement,
        previous_funding: this.previous_funding,
        achievements:this.achievements,
        potential:this.potential,
        other_comments:this.other_comments,
        needs: this.needs,
        }; 

        ApplicationService.saveApplication(formdata)
        .then((response) => {
            this.form_success = 1
            this.form_error = 0
            console.log("Good:" + response.data);
            
            this.resizeWindow(1)
           
            }).catch((error) => {
                this.form_error = 1
                this.isSubmitting = false;
                if(error.response.status === 422)
                {
                    console.log("Error:" + JSON.stringify(error.response.data));
                }
            
        });
    },
    addTrainingItem() {
        this.training.push({'details': '', 'cost' : ''})
        this.resizeWindow(0)
    },
    addSupportItem() {
        this.support.push({'finance_body': '', 'amount' : '', 'date' : '', 'comments' : ''})
        this.resizeWindow(0)
    },
    addRankingItem() {
        this.ranking.push({'area': '', 'rank' : ''})
        this.resizeWindow(0)
    },
    addNeedItem() {
        this.needs.push({'priority': '', 'comments' : ''})
        this.resizeWindow(0)
    },
    calculateAge() { // birthday is a date
            console.log(this.dob)
            var birthday = this.dob
            console.log(birthday.getTime())
            var ageDifMs = (Date.now()) - birthday.getTime();
            var ageDate = new Date(ageDifMs); // miliseconds from epoch
            
            this.age = Math.abs(ageDate.getUTCFullYear() - 1970);
        }
  }

}

</script>